document.addEventListener("DOMContentLoaded", function() {

    const indicator = document.querySelector(".tel-email-indicator");
    const telBtn = document.querySelector(".tel_btn");
    const emailBtn = document.querySelector(".email_btn");
    
    // Toggle between Tel and Email buttons in the contact form
    function moveIndicator(index) {
        if (index === "tel") {
        indicator.style.transform = "translateX(0%)";
        telBtn.classList.add("is-active");
        emailBtn.classList.remove("is-active");
        } else if (index === "email") {
        indicator.style.transform = "translateX(100%)";
        telBtn.classList.remove("is-active");
        emailBtn.classList.add("is-active");
        }
    }
    if(telBtn){
        telBtn.addEventListener("click", function (e) {
            e.preventDefault();
            moveIndicator("tel");

            // Change the text of the submit button dynamically
            if (contactFormSubmitBtn) {
                contactFormSubmitBtn.value = contactFormSubmitBtn.dataset.phoneText;
            }
        });
    }
    if(emailBtn){
        emailBtn.addEventListener("click", function (e) {
            e.preventDefault();
            moveIndicator("email");

            // Change the text of the submit button dynamically
            if (contactFormSubmitBtn) {
                contactFormSubmitBtn.value = contactFormSubmitBtn.dataset.emailText;
            }
        });
    }

    let method = 'telefon';
    const labelTel = document.getElementById('label-tel');
    const labelEmail = document.getElementById('label-email');


    function updateLabelAsterisk() {
        // Remove  asterisks from both labels
        if (labelTel) {
            labelTel.innerHTML = labelTel.textContent.replace(/\*$/, '').trim();
        }
        if (labelEmail) {
            labelEmail.innerHTML = labelEmail.textContent.replace(/\*$/, '').trim();
        }

        // Add asterisk to the selected method label
        if (method === 'telefon' && labelTel) {
            labelTel.innerHTML = labelTel.textContent.trim() + '*';
        } else if (method === 'email' && labelEmail) {
            labelEmail.innerHTML = labelEmail.textContent.trim() + '*';
        }
    }

    // Get preferred contact method
    document.querySelectorAll('.tel-or-email_config-btns a').forEach(button => {
        button.addEventListener('click', function () {
            method = this.dataset.index; // 'telefon' or 'email'
            document.querySelector('input[name="contact_method"]').value = method;
            updateLabelAsterisk();
        });
    });

    // Function for Subject
    const select = document.getElementById("email-subject");
    const input = document.getElementById("email-subject-custom");
    const selectArrow = document.getElementById("select-arrow");

    if (select && input) {
        select.addEventListener("change", function () {
            if (this.value === "other") {
                // If "other" is selected, hide the select and show the input field 
                select.style.display = "none";
                selectArrow.style.display = "none"; // Hide the arrow
                input.style.display = "block";
                input.focus();
            }
        });

        // If the input field is focused, hide the select field
        input.addEventListener("blur", function () {
            if (input.value.trim() === "") {
                input.style.display = "none";
                select.style.display = "block";
                selectArrow.style.display = "block"; // Show the arrow again
                select.value = ""; // Reset select
            }
        });
    }

    document.querySelectorAll('.goto-form-btn').forEach(button => {
        button.addEventListener('click', function() {
            const selectedSubject = this.getAttribute('data-subject');

            // Select the option which is equal to the btn data-subject
            select.value = selectedSubject;

            // if option is not found, log a warning
            if (select.value !== selectedSubject) {
                console.warn('Option not found :', selectedSubject);
            }

            // Scroll to contact form with offset
            const form = document.getElementById('kontaktformular');
            if (form) {
                const offset = 130;
                const formPosition = form.getBoundingClientRect().top;
                const offsetPosition = formPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
    

    // Frontend validation for the contact form
    var contactFormSubmitBtn = document.getElementById('contact-form_submit');
    var userdataCheckbox = document.getElementById('checkbox-userdata');
    var inputCheckboxUserdata = document.getElementById('input-checkbox-userdata');

    var telOrEmail = document.getElementById('tel-or-email');
    var invalidTelMessage = document.getElementById('not-valid-tel');
    var invalidEmailMessage = document.getElementById('not-valid-email');
    var invalidTelAndEmailMessage = document.getElementById('not-valid-tel-and-email');

    var location = document.getElementById('location');
    var plzField = document.getElementById('contact-form_plz');
    var invalidPlz = document.getElementById('not-valid-plz');

    var telefonField = document.getElementById('contact-form_telefonnummer');
    var emailField = document.getElementById('contact-form_e-mail-adresse');

    // If there is a checkbox for userdata protection, create a toggle for the checkbox
    if (userdataCheckbox && inputCheckboxUserdata) {
        userdataCheckbox.addEventListener('click', function() {
            inputCheckboxUserdata.checked = !inputCheckboxUserdata.checked; 
            userdataCheckbox.classList.toggle('checked', inputCheckboxUserdata.checked); 
        });
    
        // If the checkbox is clicked, toggle the checked class on the checkbox
        inputCheckboxUserdata.addEventListener('click', function() {
            userdataCheckbox.classList.toggle('checked', inputCheckboxUserdata.checked); 
        });
    }

    function validateEmail(emailValue) {
        // Email needs to contain @ and .
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(emailValue)) {
            return false;
        }
        return true;
    }

    function validateTel(telefonValue) {
        // Phone number can only contain numbers, space, -, (, ), ., + and /
        var phonePattern = /^[0-9()+\-\/.\s]*$/;
        
        if (!phonePattern.test(telefonValue)) {
            return false;
        }
        return true;
    }

    function validatePlz(plzValue) {
        // Validate PLZ field (postal code) - it should be a 5-digit number
        var plzPattern = /^\d{5}$/;

        if (!plzPattern.test(plzValue)) {
            return false;
        }
        return true;
    }

    // Real-time validation
    function setupRealTimeValidation() {
        // for telefon
        if (telefonField) {
            telefonField.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    if (validateTel(this.value)) {
                        this.classList.remove('required');
                        invalidTelMessage.classList.remove('show');
                    } else {
                        this.classList.add('required');
                        invalidTelMessage.classList.add('show');
                    }
                } else {
                    this.classList.remove('required');
                    invalidTelMessage.classList.remove('show');
                }
            });
        }

        // for email
        if (emailField) {
            emailField.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    if (validateEmail(this.value)) {
                        this.classList.remove('required');
                        invalidEmailMessage.classList.remove('show');
                    } else {
                        this.classList.add('required');
                        invalidEmailMessage.classList.add('show');
                    }
                } else {
                    this.classList.remove('required');
                    invalidEmailMessage.classList.remove('show');
                }
            });
        }

        // for postal code (PLZ)
        if (plzField) {
            plzField.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    if (validatePlz(this.value)) {
                        this.classList.remove('required');
                        invalidPlz.classList.remove('show');
                    } else {
                        this.classList.add('required');
                        invalidPlz.classList.add('show');
                    }
                } else {
                    this.classList.remove('required');
                    invalidPlz.classList.remove('show');
                }
            });
        }
    }

    function removeErrorMessages() {
        if (invalidEmailMessage) {
            invalidEmailMessage.classList.remove('show');
        }
        if (invalidTelMessage) {
            invalidTelMessage.classList.remove('show');
        }
        if (invalidTelAndEmailMessage) {
            invalidTelAndEmailMessage.classList.remove('show');
        }
        if (invalidPlz) {
            invalidPlz.classList.remove('show');
        }
        if (emailField) {
            emailField.classList.remove('required');
            emailField.nextElementSibling.classList.remove('show');
        }
        if (telefonField) {
            telefonField.classList.remove('required');
            telefonField.nextElementSibling.classList.remove('show');
        }
        if (plzField) {
            plzField.classList.remove('required');
        }
    }


    if (contactFormSubmitBtn) {
        contactFormSubmitBtn.addEventListener('click', function(event) {
            removeErrorMessages();
            var requiredFields = document.querySelectorAll('[required]');
            var checkboxContainer = document.getElementById('checkbox-container');

            // Check if the value of required fields are empty
            if (requiredFields) {
                requiredFields.forEach(function(field) {
                    if (field.value.trim() === '') {
                        event.preventDefault();
                        field.classList.add('required');
                        field.nextElementSibling.classList.add('show');
                    } else {
                        field.classList.remove('required');
                        field.nextElementSibling.classList.remove('show');
                    }
                })
            };

            if (location) {
                if (plzField && plzField.value.trim() !== '') {
                    if (!validatePlz(plzField.value)) {
                        event.preventDefault();
                        plzField.classList.add('required');
                        invalidPlz.classList.add('show');
                    } else {
                        plzField.classList.remove('required');
                        invalidPlz.classList.remove('show');
                    }
                }
            }
            
            // Check if the value of phone and email fields are empty if the telOrEmail field is created
            if (telOrEmail) {
                
                if (method === 'telefon' && telefonField.value.trim() === '') {
                    event.preventDefault();
                    telefonField.classList.add('required');
                    emailField.classList.remove('required');
                    telefonField.nextElementSibling.classList.add('show');
                    emailField.nextElementSibling.classList.remove('show');
                } else if (method === 'email' && emailField.value.trim() === '') {
                    event.preventDefault();
                    emailField.classList.add('required');
                    telefonField.classList.remove('required');
                    emailField.nextElementSibling.classList.add('show');
                    telefonField.nextElementSibling.classList.remove('show');
                }

                if (telefonField.value.trim() !== '') {
                    if (validateTel(telefonField.value) === false) {
                        event.preventDefault();
                        telefonField.classList.add('required');
                        invalidTelMessage.classList.add('show');
                    } else {
                        telefonField.classList.remove('required');
                        invalidTelMessage.classList.remove('show');
                        telefonField.nextElementSibling.classList.remove('show');
                    }
                }

                if (emailField.value.trim() !== '') {
                    if (validateEmail(emailField.value) === false) {
                        event.preventDefault();
                        emailField.classList.add('required');
                        invalidEmailMessage.classList.add('show');
                    } else {
                        emailField.classList.remove('required');
                        invalidEmailMessage.classList.remove('show');
                        emailField.nextElementSibling.classList.remove('show');
                    }
                }

            } else {

                // Validation for tel and email fields if the telOrEmail field is not created...
                // ... if Tel field exists and is not empty
                if (telefonField && telefonField.value.trim() !== '') {
                    if (validateTel(telefonField.value) === false) {
                        event.preventDefault();
                        telefonField.classList.add('required');
                        invalidTelMessage.classList.add('show');
                    } else {
                        telefonField.classList.remove('required');
                        invalidTelMessage.classList.remove('show');
                    }
                }

                // ... if Email field exists and is not empty
                if (emailField && emailField.value.trim() !== '') {
                    if (validateEmail(emailField.value) === false) {
                        event.preventDefault();
                        emailField.classList.add('required');
                        invalidEmailMessage.classList.add('show');
                    } else {
                        emailField.classList.remove('required');
                        invalidEmailMessage.classList.remove('show');
                    }
                }
            }

            // Check if the userdata checkbox is checked
            if (userdataCheckbox) {
                if (!userdataCheckbox.classList.contains('checked')) {
                    event.preventDefault();
                    userdataCheckbox.classList.add('required');
                    checkboxContainer.lastElementChild.classList.add('show');
                } else {
                    userdataCheckbox.classList.remove('required');
                    checkboxContainer.lastElementChild.classList.remove('show');
                }
            }
        });
    }
    setupRealTimeValidation();
});